<template>
  <main>
    <hero :title="$t('choose_language')"></hero>
    <section class="section">
      <div class="container">
        <div class="buttons">
          <sqr-button
            v-for="locale in locales"
            :key="locale.id"
            class="is-large"
            :label-raw="locale.label"
            @click="change(locale)"
          />
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'languages',
  data() {
    return {
      locales: [
        { id: 'de', label: 'Deutsch' },
        { id: 'fr', label: 'Français' },
        { id: 'en', label: 'English' }
      ]
    };
  },
  methods: {
    change(locale) {
      this.$store.dispatch({ type: 'locale', locale });
    }
  }
};
</script>
